import {Component, EventEmitter, Input, Output} from '@angular/core';
import {RangeFilterControl} from '../../../interface/range-filter-control';
import {ActivatedRoute} from '@angular/router';
import {UntilDestroy} from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'fb-range-filter-config',
  templateUrl: './range-filter-config.component.html',
  styleUrls: ['./range-filter-config.component.scss']
})
export class RangeFilterConfigComponent {
	@Output() public onControlChange: EventEmitter<null> = new EventEmitter<null>();

	@Input() public control: RangeFilterControl = {} as RangeFilterControl;

	public collapse: boolean = true;


	constructor(
		private _activeRoute: ActivatedRoute
	) { }

	public ngOnInit(): void {

	}

	public toggleCollapse(): void {
		this.collapse = !this.collapse;
	}

	public onChange(data: { min: number, max: number }): void {
		this.control.values.value1 = data.min;
		this.control.values.value2 = data.max;
		console.log("on change", data);
		this.onControlChange.emit(null);
	}
}
